import { getProfileName } from "PFCore/helpers/profile";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import css from "./shortlist_creator.module.scss";

const ShortlistCreator = ({ item: { creator } }) => {
  const { t } = useTranslation("activities");

  return (
    <div className={css.container}>
      <span className={css.addedBy}>{t("show.shortlist.addedBy")}</span>
      <Link className={css.link} to={`/profiles/${creator.id}`}>
        {getProfileName(creator)}
      </Link>
    </div>
  );
};

ShortlistCreator.propTypes = {
  item: PropTypes.shape({
    creator: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      id: PropTypes.number.isRequired
    }).isRequired
  })
};

export default ShortlistCreator;
